var _mask, _path, _path2, _mask2, _path3, _path4, _circle, _circle2, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rocket_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 67.647,
    height: 67.647,
    x: -10.04,
    y: 1.476
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.56px)",
      clipPath: "url(#rocket_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 3.112,
    filter: "url(#rocket_svg__c)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "rocket_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rocket_svg__d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rocket_svg__e)",
    fillOpacity: 0.5,
    d: "M39.655 22.962c7.341 7.341 7.341 19.244 0 26.586l-1.125 1.124c-1.812 1.813-2.718 2.719-3.449 2.847-.705.124-1.24-.003-1.813-.432-.594-.444-1.04-1.802-1.933-4.518a37.4 37.4 0 0 0-9.126-14.807 37.4 37.4 0 0 0-14.808-9.126c-2.715-.893-4.073-1.339-4.517-1.933-.429-.574-.556-1.108-.432-1.813.128-.73 1.034-1.637 2.847-3.449l1.125-1.125c7.34-7.341 19.244-7.341 26.585 0z",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#rocket_svg__f)",
    fillOpacity: 0.25,
    d: "M39.655 22.962c7.341 7.341 7.341 19.244 0 26.586l-1.125 1.124c-1.812 1.813-2.718 2.719-3.449 2.847-.705.124-1.24-.003-1.813-.432-.594-.444-1.04-1.802-1.933-4.518a37.4 37.4 0 0 0-9.126-14.807 37.4 37.4 0 0 0-14.808-9.126c-2.715-.893-4.073-1.339-4.517-1.933-.429-.574-.556-1.108-.432-1.813.128-.73 1.034-1.637 2.847-3.449l1.125-1.125c7.34-7.341 19.244-7.341 26.585 0z",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "m22.21 33.762.706-.707zM2.883 22.702l.801-.598zm-.432-1.812-.985-.173zM35.08 53.519l.173.985zm-3.746-4.95-.95.313zm1.933 4.518.599-.801zm6.387-30.125-.707.707c6.95 6.95 6.95 18.22 0 25.171l.707.707.707.708c7.732-7.732 7.732-20.269 0-28zm0 26.586-.707-.708-1.125 1.125.707.707.707.707 1.125-1.124zm-8.32-.979.95-.312a38.4 38.4 0 0 0-9.369-15.202l-.707.707-.707.707a36.4 36.4 0 0 1 8.883 14.413zm-9.126-14.807.707-.707a38.4 38.4 0 0 0-15.202-9.369l-.313.95-.312.95a36.4 36.4 0 0 1 14.413 8.883zM5.3 17.442l.707.706 1.125-1.125-.707-.707-.708-.707-1.124 1.125zm1.125-1.126.707.707c6.95-6.95 18.22-6.95 25.171 0l.707-.707.707-.707c-7.732-7.732-20.268-7.732-28 0zm26.585 0-.707.707 6.646 6.646.707-.707.707-.707-6.646-6.646zm-25.608 8.32.313-.95c-1.373-.451-2.352-.774-3.048-1.055-.745-.302-.944-.478-.98-.527l-.802.599-.801.598c.407.546 1.109.89 1.832 1.183.774.314 1.83.66 3.174 1.102zM5.3 17.441l-.707-.707c-.895.894-1.606 1.605-2.106 2.184-.475.553-.903 1.142-1.019 1.8l.985.172.985.173c.013-.073.102-.302.564-.84.44-.508 1.087-1.157 2.005-2.075zm-2.415 5.262.801-.599a1.3 1.3 0 0 1-.251-.49 1.3 1.3 0 0 1 .003-.551l-.985-.173-.985-.173c-.08.455-.087.907.021 1.36a3.3 3.3 0 0 0 .595 1.224zm35.646 27.97-.707-.708c-.918.918-1.566 1.566-2.076 2.004-.537.463-.766.552-.839.565l.173.985.173.985c.657-.115 1.247-.544 1.799-1.02.579-.499 1.29-1.21 2.184-2.105zm-7.195-2.104-.95.313c.441 1.343.788 2.4 1.102 3.174.293.723.637 1.425 1.183 1.832l.598-.801.599-.801c-.05-.037-.225-.236-.527-.981-.281-.696-.604-1.675-1.055-3.048zm3.746 4.95-.173-.985c-.25.044-.418.035-.55.003a1.3 1.3 0 0 1-.491-.251l-.599.801-.598.801c.37.277.77.487 1.224.595s.905.1 1.36.02z",
    mask: "url(#rocket_svg__g)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 66.575,
    height: 66.575,
    x: -0.566,
    y: -6.926
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.56px)",
      clipPath: "url(#rocket_svg__h)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 3.112,
    filter: "url(#rocket_svg__i)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "rocket_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rocket_svg__j"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rocket_svg__k)",
    fillOpacity: 0.2,
    d: "M52.227 2.593c.48.221.93.672 1.151 1.152.268.58.2 1.248.067 2.582-.732 7.327-2.916 22.377-8.806 28.267-1.696 1.696-5.674 4.607-10.88 8.137-1.26.855-1.891 1.282-2.476 1.344-.548.058-1-.043-1.47-.33-.502-.306-.934-1.037-1.799-2.5a37.7 37.7 0 0 0-5.806-7.482 37.7 37.7 0 0 0-7.481-5.806c-1.464-.865-2.195-1.297-2.501-1.798a2.2 2.2 0 0 1-.33-1.472c.062-.584.49-1.214 1.344-2.475 3.53-5.206 6.441-9.184 8.137-10.88 5.89-5.89 20.94-8.073 28.268-8.806 1.334-.133 2.001-.2 2.582.067",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#rocket_svg__l)",
    d: "M52.227 2.593c.48.221.93.672 1.151 1.152.268.58.2 1.248.067 2.582-.732 7.327-2.916 22.377-8.806 28.267-1.696 1.696-5.674 4.607-10.88 8.137-1.26.855-1.891 1.282-2.476 1.344-.548.058-1-.043-1.47-.33-.502-.306-.934-1.037-1.799-2.5a37.7 37.7 0 0 0-5.806-7.482 37.7 37.7 0 0 0-7.481-5.806c-1.464-.865-2.195-1.297-2.501-1.798a2.2 2.2 0 0 1-.33-1.472c.062-.584.49-1.214 1.344-2.475 3.53-5.206 6.441-9.184 8.137-10.88 5.89-5.89 20.94-8.073 28.268-8.806 1.334-.133 2.001-.2 2.582.067",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "screen"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "m52.227 2.593.418-.908zm1.151 1.152.909-.418zm.067 2.582.995.1zM44.64 34.594l.707.707zm-22.43-.83.707-.708zm-.832-22.432-.707-.707zm28.268-8.806-.1-.995zM12.226 26.16l.854-.52zm1.014-3.947-.827-.561zm-1.344 2.475.994.106zm21.863 18.044-.56-.828zm-2.476 1.344.106.995zm-3.269-2.83.861-.51zm1.798 2.5.52-.854zM52.227 2.593l-.419.909c.264.12.541.398.662.661l.908-.418.909-.418a3.48 3.48 0 0 0-1.642-1.642zm1.151 1.152-.908.418c.052.114.092.268.092.59 0 .345-.043.788-.112 1.475l.995.099.995.1c.065-.648.122-1.206.122-1.674 0-.49-.06-.96-.275-1.426zm.067 2.582-.995-.1c-.363 3.64-1.086 9.18-2.443 14.526-1.369 5.397-3.337 10.395-6.075 13.134l.707.707.707.707c3.152-3.152 5.222-8.624 6.6-14.056 1.39-5.483 2.126-11.132 2.495-14.819zM44.64 34.594l-.707-.707c-1.616 1.616-5.509 4.473-10.734 8.016l.561.828.562.827c5.185-3.516 9.249-6.48 11.025-8.257zm-16.625 6.65.861-.508a38.6 38.6 0 0 0-5.96-7.68l-.707.707-.707.707a36.7 36.7 0 0 1 5.652 7.283zm-5.806-7.48.708-.708a38.7 38.7 0 0 0-7.68-5.96l-.51.86-.508.862a36.7 36.7 0 0 1 7.283 5.652zM13.24 22.211l.828.56c3.543-5.224 6.4-9.117 8.016-10.733l-.707-.707-.707-.707c-1.776 1.776-4.741 5.84-8.257 11.026zm8.137-10.88.707.707c2.739-2.738 7.737-4.706 13.134-6.075 5.346-1.356 10.886-2.079 14.526-2.443l-.1-.995-.099-.995c-3.687.369-9.336 1.104-14.819 2.494-5.432 1.379-10.904 3.448-14.056 6.6zm28.268-8.806.1.995c.686-.068 1.129-.111 1.473-.111.322 0 .477.04.59.092l.419-.909.418-.908c-.467-.215-.937-.275-1.427-.275-.467 0-1.025.057-1.673.121zm-34.918 25.43.508-.86c-.744-.44-1.257-.744-1.625-.997-.375-.259-.49-.395-.53-.46l-.854.52-.854.52c.266.436.669.767 1.102 1.066.44.303 1.025.648 1.744 1.073zm-1.487-5.744-.827-.561c-.419.617-.766 1.127-1.01 1.557-.248.432-.449.878-.502 1.374l.995.105.994.106c.01-.089.053-.25.25-.594.197-.347.492-.782.928-1.426zm-1.014 3.947.854-.52a1.22 1.22 0 0 1-.19-.846l-.994-.106-.995-.105a3.2 3.2 0 0 0 .471 2.097zM33.759 42.73l-.56-.828c-.645.437-1.08.73-1.427.929-.344.196-.505.24-.594.249l.105.994.106.995c.496-.053.942-.254 1.374-.501.43-.245.94-.592 1.558-1.01zm-5.745-1.487-.86.509c.424.718.769 1.304 1.072 1.744.3.433.63.836 1.066 1.102l.52-.854.52-.854c-.065-.04-.201-.155-.46-.53-.253-.368-.557-.88-.997-1.625zm3.27 2.831-.106-.994a1.22 1.22 0 0 1-.845-.19l-.52.854-.521.854c.658.401 1.33.552 2.097.47z",
    mask: "url(#rocket_svg__m)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 38.603,
    height: 38.603,
    x: 17.03,
    y: 3.4
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.53px)",
      clipPath: "url(#rocket_svg__n)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 3.063,
    filter: "url(#rocket_svg__o)",
    shapeRendering: "crispEdges",
    transform: "rotate(45 36.332 19.638)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.332,
    cy: 19.638,
    r: 7.049,
    fill: "url(#rocket_svg__p)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 36.332,
    cy: 19.638,
    r: 7.049,
    fill: "url(#rocket_svg__q)",
    style: {
      mixBlendMode: "screen"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.332,
    cy: 19.638,
    r: 6.549,
    stroke: "#fff",
    strokeOpacity: 0.25
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 38.087,
    height: 38.087,
    x: -8.065,
    y: 29.011
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.53px)",
      clipPath: "url(#rocket_svg__r)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 3.063,
    filter: "url(#rocket_svg__s)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rocket_svg__u)",
    d: "M16.393 46.223c-1.094 1.095-5.609 3.246-9.076 4.806-1.267.57-1.9.855-2.326.722a1.2 1.2 0 0 1-.772-.772c-.133-.425.152-1.059.722-2.326 1.56-3.467 3.712-7.982 4.806-9.076a4.7 4.7 0 0 1 6.646 6.646"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#rocket_svg__v)",
    strokeOpacity: 0.5,
    d: "M16.04 39.93a4.2 4.2 0 0 1 0 5.94c-.227.226-.668.54-1.297.918a38 38 0 0 1-2.226 1.218c-1.688.864-3.674 1.788-5.405 2.567-.643.29-1.093.491-1.435.608-.353.12-.487.109-.538.093a.7.7 0 0 1-.443-.444c-.016-.05-.026-.184.094-.537.116-.342.318-.792.608-1.435.778-1.73 1.702-3.717 2.566-5.405a38 38 0 0 1 1.218-2.226c.379-.628.692-1.07.919-1.297a4.2 4.2 0 0 1 5.938 0Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__e",
    x1: 28.227,
    x2: 18.068,
    y1: 27.744,
    y2: 37.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__k",
    x1: 38.739,
    x2: 20.989,
    y1: 17.232,
    y2: 34.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__p",
    x1: 36.332,
    x2: 36.332,
    y1: 18.845,
    y2: 26.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__u",
    x1: 16.503,
    x2: 5.483,
    y1: 39.882,
    y2: 50.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__v",
    x1: 18.775,
    x2: 9.541,
    y1: 41.959,
    y2: 46.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rocket_svg__b",
    transform: "translate(10.04 -1.476)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rocket_svg__d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rocket_svg__h",
    transform: "translate(.566 6.926)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rocket_svg__j"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rocket_svg__n",
    transform: "translate(-17.03 -3.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.332,
    cy: 19.638,
    r: 7.049,
    transform: "rotate(45 36.332 19.638)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rocket_svg__r",
    transform: "translate(8.065 -29.011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.393 46.223c-1.094 1.095-5.609 3.246-9.076 4.806-1.267.57-1.9.855-2.326.722a1.2 1.2 0 0 1-.772-.772c-.133-.425.152-1.059.722-2.326 1.56-3.467 3.712-7.982 4.806-9.076a4.7 4.7 0 0 1 6.646 6.646"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rocket_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rocket_svg__c",
    width: 67.647,
    height: 67.647,
    x: -10.04,
    y: 1.476,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.223
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4492_28721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4492_28721",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rocket_svg__i",
    width: 66.575,
    height: 66.575,
    x: -0.566,
    y: -6.926,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.223
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4492_28721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4492_28721",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rocket_svg__o",
    width: 38.603,
    height: 38.603,
    x: 17.03,
    y: 3.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.126
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4492_28721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4492_28721",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rocket_svg__s",
    width: 38.087,
    height: 38.087,
    x: -8.065,
    y: 29.011,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.126
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4492_28721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4492_28721",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "rocket_svg__f",
    width: 1.6,
    height: 2.911,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rocket_svg__t",
    transform: "scale(.00156 .00284)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "rocket_svg__l",
    width: 2.286,
    height: 1.666,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rocket_svg__t",
    transform: "scale(.00223 .00163)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "rocket_svg__q",
    width: 5.25,
    height: 5.25,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rocket_svg__t",
    transform: "scale(.00513)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rocket_svg__d",
    d: "M39.655 22.962c7.341 7.341 7.341 19.244 0 26.586l-1.125 1.124c-1.812 1.813-2.718 2.719-3.449 2.847-.705.124-1.24-.003-1.813-.432-.594-.444-1.04-1.802-1.933-4.518a37.4 37.4 0 0 0-9.126-14.807 37.4 37.4 0 0 0-14.808-9.126c-2.715-.893-4.073-1.339-4.517-1.933-.429-.574-.556-1.108-.432-1.813.128-.73 1.034-1.637 2.847-3.449l1.125-1.125c7.34-7.341 19.244-7.341 26.585 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rocket_svg__j",
    d: "M52.227 2.593c.48.221.93.672 1.151 1.152.268.58.2 1.248.067 2.582-.732 7.327-2.916 22.377-8.806 28.267-1.696 1.696-5.674 4.607-10.88 8.137-1.26.855-1.891 1.282-2.476 1.344-.548.058-1-.043-1.47-.33-.502-.306-.934-1.037-1.799-2.5a37.7 37.7 0 0 0-5.806-7.482 37.7 37.7 0 0 0-7.481-5.806c-1.464-.865-2.195-1.297-2.501-1.798a2.2 2.2 0 0 1-.33-1.472c.062-.584.49-1.214 1.344-2.475 3.53-5.206 6.441-9.184 8.137-10.88 5.89-5.89 20.94-8.073 28.268-8.806 1.334-.133 2.001-.2 2.582.067"
  }))));
};
export default SvgRocket;